import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoisturizerGlyphSecondary from './svgs/MoisturizerGlyphSecondary.js';
import SvgMoisturizerGlyph from './svgs/MoisturizerGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moisturizerGlyph = (props => useIcon(SvgMoisturizerGlyph, SvgMoisturizerGlyphSecondary, props));

export { moisturizerGlyph as default };
